import { Box, Stack, Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIconFresh } from "source/components/framework/List/ListStateIconFresh";
import { ListStateIconLocked } from "source/components/framework/List/ListStateIconLocked";
import { ListStateIconUnread } from "source/components/framework/List/ListStateIconUnread";
import { ListStateIconApproved } from "source/components/framework/List/ListStateIconApproved";
import { EnumHelper, RiskTreatmentState } from "ui/Scripts/source/models/enums";
import { IRiskAssessmentListItem } from "ui/Scripts/source/models/riskAssessment/riskAssessmentListItem";
import { ListStateIconError } from "source/components/framework/List/ListStateIconError";
import { residualRiskLevelThreshold } from "ui/Scripts/source/models/consts";

interface IRiskEditDialogAssessmentListAssessorColProps {
    isReadOnly: boolean;
    item: IRiskAssessmentListItem
}

export const RiskEditDialogAssessmentListAssessorCol = (props: IRiskEditDialogAssessmentListAssessorColProps) => {
    return (
        <Stack direction="row" useFlexGap flexWrap="nowrap" overflow="hidden" alignItems="center">
            <Tooltip title={props.item.assessor}>
                <Box sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{props.item.assessor}</Box>
            </Tooltip>
            {props.item.treatmentState === RiskTreatmentState.Late &&
                <ListStateIconError tooltip={Translations.RiskTreatmentIsLate} />
            }
            <ListStateIconUnread unread={!props.item.isRead} />
            <ListStateIconFresh date={props.item.modifyUser.date} />
            {props.item.residualRiskLevel >= residualRiskLevelThreshold &&
                <ListStateIconApproved
                    customColor={EnumHelper.getApprovalTypeColor(props.item.approval)}
                    tooltip={EnumHelper.getApprovalTypeListText(props.item.approval)}
                />
            }
            {!props.isReadOnly &&
                <ListStateIconLocked locked={props.item.locked} />
            }
        </Stack>
    );
};
